import type {
  AccelerationContentFields,
  AccelerationFormState,
  AccelerationStepReadOnlyFlags,
  AccelerationStepperVariant
} from '@/components/AccelerationForm/AccelerationForm.types'
import { normalizeAccelerationContentDetails } from '@/components/AccelerationForm/utils/detailRichItems'
import { INITIAL_CAMPAIGN_BRAND_FLAGS } from '@/constants/campaignBrands'

/** Itens do FloraStepper (ordem: pontuação → visual → detalhes). */
export const ACCELERATION_STEP_LABELS = [
  { id: 'configuration', text: 'Configuração' },
  { id: 'visual', text: 'Visual' },
  { id: 'details', text: 'Detalhes' }
] as const

export const ACCELERATION_STEP_INDEX = {
  POINTS: 0,
  VISUAL: 1,
  DETAILS: 2
} as const

export const INITIAL_ACCELERATION_CONTENT: AccelerationContentFields = {
  title: '',
  description: '',
  imageUrl: '',
  imageKey: '',
  buttonText: 'Comprar agora',
  buttonUrl: '',
  showModal: false,
  details: normalizeAccelerationContentDetails(null)
}

export const INITIAL_ACCELERATION_FORM_STATE: AccelerationFormState = {
  segmentation: { campaignType: '', audienceType: '' },
  pointsValidityType: '',
  name: '',
  type: '',
  point: '',
  multiplier: '',
  startDate: '',
  endDate: '',
  points: { type: '', description: '', startDate: '', endDate: '', countOfDays: '' },
  brand: { ...INITIAL_CAMPAIGN_BRAND_FLAGS },
  contentByBrand: {},
  content: INITIAL_ACCELERATION_CONTENT
}

export const ACCELERATION_STEPPER_VARIANT = {
  CREATE: 'create',
  VIEW: 'view',
  EDIT: 'edit'
} as const satisfies Record<string, AccelerationStepperVariant>

/** Presets de readonly por modo do stepper; `stepReadOnly` na prop sobrescreve por campo. */
export const ACCELERATION_STEP_READ_ONLY_DEFAULTS: Record<AccelerationStepperVariant, AccelerationStepReadOnlyFlags> = {
  [ACCELERATION_STEPPER_VARIANT.CREATE]: { configuration: false, visual: false, details: false },
  [ACCELERATION_STEPPER_VARIANT.VIEW]: { configuration: true, visual: true, details: true },
  [ACCELERATION_STEPPER_VARIANT.EDIT]: { configuration: true, visual: false, details: false }
}
